import { useState } from "react";
import { Plus, Minus } from "lucide-react";

const FAQS = [
  {
    q: "¿Mi hijo necesita un móvil para usar Kiddio?",
    a: "No. Kiddio funciona por sí solo con su propia red 4G. Tú lo gestionas todo desde tu móvil, pero él no necesita ninguno.",
  },
  {
    q: "¿Quién puede llamar o escribir a mi hijo?",
    a: "Solo las personas que tú apruebes desde la app. Nadie fuera de esa lista puede contactar con el reloj.",
  },
  {
    q: "¿Cómo funcionan las zonas seguras?",
    a: "Tú marcas lugares como el cole o casa de los abuelos. Recibes un aviso amable cuando tu hijo entra o sale de ellos. Nada de vigilancia constante.",
  },
  {
    q: "¿Qué pasa si pulsa el botón SOS?",
    a: "Con un toque prolongado, todos los contactos de la familia reciben una alerta con su ubicación para poder actuar enseguida.",
  },
  {
    q: "¿Cuánto dura la batería?",
    a: "Hasta 3 días con un uso normal. Se carga en poco más de una hora con el cable magnético incluido.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-[#F3F2F2] border-b-2 border-[#12263A]">
      <div className="max-w-3xl mx-auto px-5 py-16 md:py-24">
        <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#2E9EF0]">Preguntas frecuentes</span>
        <h2 className="mt-3 text-[28px] md:text-[40px] font-black text-[#12263A] leading-tight">
          Lo que las familias nos preguntan.
        </h2>

        <div className="mt-10 space-y-4">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                data-testid={`faq-item-${i}`}
                className="bg-white border-2 border-[#12263A]"
                style={{ borderRadius: "20px" }}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-6 py-5"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="text-[17px] font-black text-[#12263A]">{f.q}</span>
                  {isOpen ? (
                    <Minus size={22} strokeWidth={2.5} className="text-[#2E9EF0] shrink-0" />
                  ) : (
                    <Plus size={22} strokeWidth={2.5} className="text-[#12263A] shrink-0" />
                  )}
                </button>
                {isOpen && (
                  <p className="px-6 pb-6 -mt-1 text-[15px] leading-[1.6] text-[#2A3D52]">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
